@if (!isPdf) {
  <div class="image-container {{ isImageProcessing ? 'state-processing' : 'state-loaded'}} {{ imageLoadFailed ? 'state-failed' : ''}}">
    <img [src]="thumbnailUrl" (click)="viewImage()" alt="" (error)="onImageError($event)" (load)="onImageLoad($event)" />
    @if (enableImagesManagement && !(isLoading || isImageProcessing)) {
      <a (click)="removeFile.emit()" class="remove">
        <i aria-hidden="true" class="far fa-times"></i>
      </a>
    }
    @if (imageLoadFailed) {
      <div class="loading-failed">
        <i class="far fa-image-slash"></i>
      </div>
    }

    @if ((isLoading || isImageProcessing) && !imageLoadFailed) {
      <div class="loading">
        <div class="spinner-border text-light" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    }
  </div>
} @else {
  <div class="image-container state-loaded">
    <a (click)="viewImage()" title="View PDF" class="pdf-icon">
      <i class="far fa-file-pdf"></i>
    </a>
    @if (enableImagesManagement && !isLoading) {
      <a (click)="removeFile.emit()" class="remove">
        <i aria-hidden="true" class="far fa-times"></i>
      </a>
    }
    @if (isLoading) {
      <div class="loading">
        <div class="spinner-border text-light" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    }
  </div>
}

<!-- Modal for zoomable image / PDF viewer -->
@if (showZoomModal) {
  <div class="zoom-modal-backdrop">
    <div class="zoom-modal">
      <button class="close-btn" (click)="closeZoomModal()">&times;</button>
      @if (receipt) {
        <div class="receipt-details">
          <span><strong>Amount:</strong><br>
            <app-expense-ai-amount
              [currency]="receipt.currency"
              [amount]="receipt.amount"
              [hasAiData]="!!claimAmount"
              [matches]="receipt.amount === claimAmount && receipt.currency === claimCurrency"
              [mismatchReason]="receipt.currency !== claimCurrency ? 'Receipt currency (' + receipt.currency + ') does not match claim currency (' + claimCurrency + ')' : 'Receipt amount (' + (receipt.amount | number:'1.2-2') + ') does not match claim amount (' + (claimAmount | number:'1.2-2') + ')'">
            </app-expense-ai-amount>
          </span>
          <span><strong>Category Name:</strong><br>
            <app-expense-ai-category
              [categoryName]="receipt.categoryName"
              [hasAiData]="!!claimCategory"
              [matches]="receipt.categoryName === claimCategory"
              [mismatchReason]="'AI categorised receipt as \'' + receipt.categoryName + '\' but claim category is \'' + claimCategory + '\''">
            </app-expense-ai-category>
          </span>
          <span><strong>Transaction Date:</strong><br>
            @if (!visitDate || !receipt.transactionDate) {
              <span>{{ receipt.transactionDate | date: 'd MMM yyyy' }}</span>
            }
            @if (visitDate && receipt.transactionDate) {
              <span class="ai-verified-badge"
                [ngClass]="dateMatchesVisit ? 'ai-match' : 'ai-mismatch'"
                [attr.data-tooltip]="!dateMatchesVisit ? 'Receipt date (' + (receipt.transactionDate | date: 'd MMM yyyy') + ') falls outside the visit date range (' + (visitDate | date: 'd MMM yyyy') + (visitEndDate ? ' - ' + (visitEndDate | date: 'd MMM yyyy') : '') + (visitTravelDays ? ' +/- ' + visitTravelDays + ' travel days' : '') + ')' : null">
                <i class="far fa-brain-circuit"></i> {{ receipt.transactionDate | date: 'd MMM yyyy' }}
              </span>
            }
          </span>
          @if (receipt.merchantName) {
            <span><strong>Merchant:</strong><br> {{ receipt.merchantName }}</span>
          }
          @if (receipt.legitimacyConfidence != null) {
            <span><strong>Legitimacy:</strong><br>
              <span class="legitimacy-badge" [ngClass]="{
                'legitimacy-high': receipt.legitimacyConfidence >= 70,
                'legitimacy-medium': receipt.legitimacyConfidence >= 40 && receipt.legitimacyConfidence < 70,
                'legitimacy-low': receipt.legitimacyConfidence < 40
              }">{{ receipt.legitimacyConfidence }}%</span>
            </span>
          }
        </div>
      }

      <!-- Image viewer with panzoom -->
      @if (!isPdf) {
        <div class="zoom-modal-toolbar">
          <button class="rotate-btn" (click)="rotateLeft()" title="Rotate left" type="button">⟲</button>
          <button class="rotate-btn" (click)="rotateRight()" title="Rotate right" type="button">⟳</button>
          <button class="zoom-btn" (click)="zoomIn()" title="Zoom in" type="button">＋</button>
          <button class="zoom-btn" (click)="zoomOut()" title="Zoom out" type="button">－</button>
          <button class="reset-btn" (click)="reset()" title="Reset" type="button"><i class="far fa-window-restore"></i></button>
        </div>
        <div #panzoomImageWrapper class="zoom-image-wrapper">
          @if (imageUrl) {
            <img
              [src]="imageUrl"
              [ngStyle]="{'transform': 'rotate(' + rotation + 'deg)'}"
              alt="Zoomed expense image"
              draggable="false"
              style="max-width:100%;max-height:100%;display:block;margin:0 auto;"
            />
          }
        </div>
      }

      <!-- PDF viewer with iframe -->
      @if (isPdf) {
        <div class="pdf-viewer-wrapper">
          @if (pdfUrl) {
            <iframe [src]="pdfUrl" class="pdf-iframe"></iframe>
          }
        </div>
      }
    </div>
  </div>
}
